import axios from "axios";

//const URL = "http://localhost:5000/";
const BASE_URL = "https://genes-api.onrender.com";

export const api = axios.create({ baseURL: BASE_URL });

export function getGeneInfo(gene) {
  return api.get(`/genes?search=${gene}`);
}